import { useNavigate } from "react-router-dom";
import Button from "@/shared/components/Button";
import LinearLayout from "@/shared/components/LinearLayout";

const KycFormSuccess = () => {
  const navigate = useNavigate();

  return (
    <div className="w-[350px]">
      <LinearLayout orientation="vertical">
        <div className="mx-auto space-y-6 text-center">
          <h1 className="font-inter h-[24px] w-[272px] text-center text-[20px] font-medium leading-[24px] tracking-[0px] text-white opacity-100">
            KYC Verification Successful!
          </h1>
          <p className="font-inter mx-auto h-[68px] w-[320px] text-center text-[14px] font-normal leading-[17px] tracking-[0px] text-white opacity-100">
            Your identity has been successfully verified. You can now enjoy all
            the benefits of your Nommia Membership, including deposits, trading,
            and withdrawals.
          </p>
          <p className="font-inter mx-auto h-[51px] w-[296px] py-10 text-center text-[14px] font-normal leading-[17px] tracking-[0px] text-white opacity-50">
            Account Fully Activated. Faster Deposits, Withdrawals &amp;
            Transactions Increased Security.
          </p>
          <Button
            variant="primary"
            fluid
            onClick={() => navigate("/plan/membership-confirm")}>
            Continue
          </Button>
        </div>
      </LinearLayout>
    </div>
  );
};

export default KycFormSuccess;
